import * as React from 'react';
import * as moment from 'moment';

interface Props {
  company: any;
  driver: any;
}

export default ({ company, driver }: Props) => (
  <table>
    <tbody>
      <tr>
        <th>Full Name</th>
        <td>{driver.name}</td>
      </tr>
      <tr>
        <th>Date of Birth</th>
        <td>
          {!!driver.date_of_birth &&
            moment(driver.date_of_birth).format('DD/MM/YYYY')}
        </td>
      </tr>
      <tr>
        <th>Address</th>
        <td>
          {driver.address}
          {!!driver.address_2 && (
            <>
              <br />
              {driver.address_2}
            </>
          )}
          {!!driver.city && (
            <>
              <br />
              {driver.city}
            </>
          )}
          {!!driver.county && (
            <>
              <br />
              {driver.county}
            </>
          )}
          {!!driver.postcode && (
            <>
              <br />
              {driver.postcode}
            </>
          )}
        </td>
      </tr>
      <tr>
        <th>Phone Number</th>
        <td>{driver.phone_number}</td>
      </tr>
      <tr>
        <th>Email</th>
        <td>{driver.email}</td>
      </tr>
      <tr>
        <th>Occupation</th>
        <td>{driver.occupation}</td>
      </tr>
      <tr>
        <th>Company</th>
        <td>
          {company.name ? (
            company.name
          ) : (
            <span className="has-text-grey-light">N/A</span>
          )}
        </td>
      </tr>
    </tbody>
  </table>
);
